
import Data from './Data'
import AvailabilityData from './AvailabilityData'

import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';

import Period from '../../../../helpers/Period';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';


// Material components
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import RefreshIcon from '@material-ui/icons/Refresh';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import HelpIcon from '@material-ui/icons/Help';
import CloseIcon from '@material-ui/icons/Clear';

// Palette
import palette from 'theme/palette';


// Component styles
import styles from './styles';
import Grid from '@material-ui/core/Grid';

import moment from 'moment'
import 'moment/locale/es'
import { withTranslation } from 'react-i18next';
moment.locale('es')


class DownloadData extends Component {
    constructor(props) {
        super(props);
        this.handleDataClick = this.handleDataClick.bind(this);
        this.handleAvailabilityDataClick = this.handleAvailabilityDataClick.bind(this);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.handleNextStepClick = this.handleNextStepClick.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.handleFirstInfo = this.handleFirstInfo.bind(this);
        this.handleDateMoment = this.handleDateMoment.bind(this);
        this.translation = (this.props && this.props.t) ? this.props.t : (s => s);
        this.state = {
            typeGraph: 0,
            period: 'd',
            step: 0,
            isForStep: false,
            nameStep: null,
            namePeriod: null,
            x: null,
            y: null,
            isLastEvent: false,
            objetive: this.props.match.params.objetivo_id,
            statePeriod: {},
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            nameGraph: [' ', ' Disponibilidad por día'],
            namePeriodPorlet: [this.translation('period.text.last-hour'), this.translation('period.text.last-day'), this.translation('period.text.last-week'), this.translation('period.text.custom'), this.translation('period.text.last-3-hours'), this.translation('period.text.last-3-days')],
            typePeriod: 1,
            settingsEl: null,
            isRefresh: false,
            isInfo: null,
            checkedA: false,
            date: new Date(),
            dateMoment:((moment().locale('es')).format("DD/MM/YYYY, h:mm:ss a")),
            isOneHour: true,
            detalleGraph:[' Puede descargar un archivo CSV con toda la información obtenida de un objetivo durante el período y horario seleccionado.\n '+
                          ' Debe seleccionar el juego de caracteres (Codificación) del archivo y el carácter de separación entre las columnas.', 
                        '  Puede descargar un archivo CSV con toda la información obtenida de un objetivo durante el período y horario seleccionado. Debe seleccionar el juego de caracteres (Codificación) del archivo y el carácter de separación entre las columnas. ']
        };
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
     }
     
     tick() {
         if(this.state.checkedA===true){
             this.setState({
             date: new Date(),
             dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))
             });
         }
     }

     handleChange = name=>event => {
        this.setState({ 
            checkedA: event.target.checked 
        });
        this.timerID = setInterval(
            () => this.tick(),
            300000
          );
      };


    handleDataClick() {
        this.setState({
            typeGraph: 0,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: false,
        });
    }

    handleAvailabilityDataClick() {
        this.setState({
            typeGraph: 1,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: false,
        });
    }

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        if (nextPeriod === 'hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                namePeriod: 'Rango: última hora',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: '3h',
                typePeriod: 4,
                namePeriod: 'Rango: últimas 3 horas',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: 'Rango: último día',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        }  else if (nextPeriod === '3dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 5,
                namePeriod: 'Rango: últimos 3 días',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'semana') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 2,
                namePeriod: 'Rango: última semana',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'custom') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "c",
                typePeriod: 3,
                namePeriod: 'Rango: ' + statePeriod.startDate.toISOString().substring(0, 10) + ' a ' + statePeriod.endDate.toISOString().substring(0, 10),
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
                isRefresh: false
            });
        }
    }

    handleNextStepClick(propsStep, nextStep) {
        const prevPeriod = propsStep.period
        const prevTypeGraph = propsStep.typeGraph
        const newStep = nextStep
        if (propsStep.step !== newStep) {
            this.setState({
                typeGraph: prevTypeGraph,
                period: prevPeriod,
                step: newStep,
                isLastEvent: false
            })
        }
    }

    handleInfo(props, step) {
        this.setState({
            nameStep: step,
            x: props.x,
            y: props.y
        })
    }

    handleFirstInfo(props) {
        if (!this.state.isLastEvent && props.name !== null) {
            this.setState({
                nameStep: props.name,
                x: props.x,
                y: props.y,
                namePeriod: props.namePeriod,
                isLastEvent: true
            })
        }
    }
    handleDateMoment(props) {
        this.setState({
            dateMoment: props,
            isRefresh: false
        })
    }

    handleShowResponseTimeGraph = event => {
        this.setState({
            responseTimeGraphEl: event.currentTarget
        });
    };

    handleCloseResponseTimeGraph = () => {
        this.setState({
            responseTimeGraphEl: null
        });
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handleRefresh = event => {
        this.setState({
            isRefresh: true,
            settingsEl: null,
        })
    }

    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };
    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    componentDidUpdate(prevProps, prevState) {
        /*if (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) {
            this.setState({
                typeGraph: 0,
                period: this.state.period,
                step: this.state.step,
                isForStep: false,
                nameStep: null,
                x: null,
                y: null,
                isLastEvent: false,
                objetive: this.props.match.params.objetivo_id,
                periodEl: null
            })
        }*/
    }
    handleClose = event => {

        this.props.onClose()
    };

    render() {
        const { classes, className, location } = this.props;
        const { typeGraph, period, step, x, y, nameStep, statePeriod, isStatePeriod, namePeriod, responseTimeGraphEl, periodEl,
             nameGraph, namePeriodPorlet, typePeriod, settingsEl, isRefresh,isInfo, detalleGraph,date, dateMoment, isOneHour } = this.state;

        let buttonData;
        let buttonDataDay;
        const showResponseTimeGraphEl = Boolean(responseTimeGraphEl);
        const showPeriodEl = Boolean(periodEl);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);

        const t = this.translation
        buttonData = <DataButton t={t} onClick={this.handleDataClick} />;
        buttonDataDay = <DataDayButton t={t} onClick={this.handleAvailabilityDataClick} />;

        const rootClassName = classNames(classes.root, className);
        const divStyle = {
            top: '25%',left: '21%', width:'500px'
          };
        return (
                <Portlet
                    /*  {...rest} */
                    className={rootClassName}
                >
                    <PortletHeader className={classes.header}
                    >
                        <PortletLabel
                            /*  icon={<DevicesIcon />} */
                            variant="h6"
                            title={this.props.title+t(`monitoring.tools-section.download-data.modal.name-graph.${typeGraph}`)}
                        />

                        <PortletToolbar className={classes.portletToolbar}>
                            <IconButton
                                //className={classes.refreshButton}
                                //variant="text"
                                onClick={this.handleShowSettings}
                            >
                                <SettingsOutlinedIcon />
                                
                            </IconButton>
                            <Popover
                                anchorEl={settingsEl}
                                
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                onClose={this.handleCloseSettings}
                                open={showSettingsEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}>
                                {/*<IconButton
                                    className={classes.refreshButton}
                                    variant="text"
                                    onClick={this.handleRefresh}
                                    onClose={this.handleCloseSettings}
                                >             
                                    <RefreshIcon color="primary" /><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>Actualizar</Typography>
                                </IconButton>*/}
                                <IconButton
                                        onClick={this.handleShowIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                    >
                                        <HelpIcon color="secondary"/><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>{t('monitoring.tools-section.download-data.modal.information')}</Typography>
                                </IconButton>
                                <Popover
                                    anchorEl={isInfo}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    open={showIsInfo}
                                    onClose={this.handleCloseIsInfo}
                                    style={{width:'1000px'}}
                                >
                                    <PortletContent variant="h4" style={{fontSize:'16px', color:'#66788A'}}>{t(`monitoring.tools-section.download-data.modal.information.description.${typeGraph}`)}</PortletContent>
                                </Popover>
                                {/*<Tooltip title="Actualización Automatica cada 5 minutos">
                                        <div style={{textAlign:"center"}}>
                                            <Switch
                                                checked={this.state.checkedA}
                                                onChange={this.handleChange('checkedA')}
                                                value="checkedA"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />
                                        </div>
                            </Tooltip>*/}

                            </Popover>
                            <Button
                                color="primary"
                                variant="text"
                                onClick={this.handleShowResponseTimeGraph}
                            >
                                {t('monitoring.tools-section.download-data.modal.select-type-graph.component')} <ArrowRightIcon />
                            </Button>
                            <IconButton className={classes.buttonClosed} onClick={this.handleClose}><CloseIcon/></IconButton>
                            <Popover
                                anchorEl={responseTimeGraphEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center'
                                }}
                                onClose={this.handleCloseResponseTimeGraph}
                                open={showResponseTimeGraphEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center'
                                }}>
                                <div>
                                    {buttonData}
                                    {buttonDataDay}
                                </div>

                            </Popover>
                        </PortletToolbar>
                    </PortletHeader>
                    <PortletContent className={classes.content}>
                        <Grid
                            container
                            spacing={10}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}>
                                
                                    <div >
                                        {period == 'c' ?
                                            <div >
                                                <Typography color="textSecondary" gutterBottom>
                                                    {t('text.from')} {statePeriod.startDate.toISOString().substring(0, 10)} {t('text.to')} {statePeriod.endDate.toISOString().substring(0, 10)}
                                                </Typography>
                                            </div>
                                        : null}
                                        {<Graph
                                            typeGraph={typeGraph}
                                            period={period}
                                            step={step}
                                            onInfo={this.handleInfo}
                                            onFirstInfo={this.handleFirstInfo}
                                            statePeriod={statePeriod}
                                            isStatePeriod={isStatePeriod}
                                            isRefresh={isRefresh} 
                                            date={date}
                                            onDateMoment={this.handleDateMoment}/>}
                                        
                                    </div>
                                    {/*<div style={{float:"right", marginTop:"5%"}}>
                                        <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                
                                                
                                            <Avatar variant="rounded" className={classes.rounded}>
                                            <UpdateIcon /> 
                                            </Avatar>
                                            <Typography  className={classes.updateTime}   >
                                                    &nbsp; Última actualización: {dateMoment} 
                                            </Typography>
                                            
                                        </div>
                                            </div>  */}          
                                    
                                
                            </Grid>
                        </Grid>
                    </PortletContent>
                    <PortletFooter className={classes.portletFooter}>
                        <Button  variant="h4" style={{fontSize:'15px',float:'left', color:'#66788A'}} onClick={this.handleShowPeriod}>
                            {namePeriodPorlet[typePeriod]}<ArrowDropDownIcon />
                        </Button>
                        <Popover
                            anchorEl={periodEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleClosePeriod}
                            open={showPeriodEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <Period onClick={this.handlePeriodClick} period={period} typeGraph={typeGraph} isOneHour={isOneHour} />
                        </Popover>
                        {/*<Button
                            color="primary"
                            variant="text"
                            //onClick={this.handleShowResponseTimeGraph}
                        >
                            Información Extendida <ArrowRightIcon />
                        </Button>*/}
                        {/*<Popover
                            anchorEl={responseTimeGraphEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleCloseResponseTimeGraph}
                            open={showResponseTimeGraphEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <div>
                                {buttonData}
                            </div>*/
                            /*<div >
                                {isForStep ? <div className="row1"><List component="div">
                                    {Object.values(location.state.fromObjectives.Pasos).map(i => (
                                    
                                        <ListItem
                                        className={classes.listItem}
                                        component="div"
                                        >
                                        <ListItemIcon
                                            className={classes.listItemIcon}
                                        >
                                        </ListItemIcon>
                                        <ListItemText
                                            classes={{ secondary: classes.listItemTextSecondary }}
                                            primary={i.nombre_paso}
                                        />
                                        </ListItem>))}
                                </List>
                                </div> : null}
                                    </div>

                                    </Popover>*/}
                        
                    </PortletFooter>
                </Portlet>

        )
    }
}

function Graph(props) {
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {
        return <Data params={props} />;
    }
    if (typeGraph === 1) {
        return <AvailabilityData params={props} />;
    }
}

function DataButton(props) {
    return (
        <Button onClick={props.onClick}>
            {props.t('monitoring.tools-section.download-data.modal.select-type-graph.option.data')}
      </Button>
    );
}

function DataDayButton(props) {
    return (
        <Button onClick={props.onClick}>
            {props.t('monitoring.tools-section.download-data.modal.select-type-graph.option.availability-by-day')}
      </Button>
    );
}

export default
    compose(withRouter, withStyles(styles), withTranslation())(DownloadData);